import React, { ReactNode } from 'react';
import styles from './AccordionPanel.module.scss';

interface AccordionPanelProps {
  title: string;
  children: ReactNode;
}

const QuestionIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <mask
        id="mask0_7171_27456"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <rect width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_7171_27456)">
        <path
          d="M7.31034 10.5131C7.31034 9.75845 7.39729 9.18068 7.57117 8.77979C7.74506 8.3789 8.10812 7.93445 8.66034 7.44645C9.09023 7.06357 9.41606 6.71634 9.63784 6.40479C9.85962 6.09323 9.97051 5.74001 9.97051 5.34512C9.97051 4.82123 9.79212 4.38579 9.43534 4.03879C9.07845 3.69179 8.58718 3.51829 7.96151 3.51829C7.39062 3.51829 6.94617 3.67123 6.62817 3.97712C6.31029 4.28312 6.06884 4.62462 5.90384 5.00162L4.68717 4.46695C4.94617 3.82851 5.35045 3.29623 5.90001 2.87012C6.44956 2.44412 7.13673 2.23112 7.96151 2.23112C9.0384 2.23112 9.86723 2.53473 10.448 3.14195C11.0288 3.74918 11.3192 4.4699 11.3192 5.30412C11.3192 5.82545 11.2062 6.28551 10.9802 6.68429C10.7541 7.08295 10.4111 7.49812 9.95134 7.92979C9.37268 8.46056 9.01434 8.87912 8.87634 9.18545C8.73823 9.4919 8.66918 9.93445 8.66918 10.5131H7.31034ZM7.96151 14.3336C7.68884 14.3336 7.45401 14.2351 7.25701 14.0381C7.06001 13.8411 6.96151 13.6063 6.96151 13.3336C6.96151 13.061 7.06001 12.8261 7.25701 12.6291C7.45401 12.4321 7.68884 12.3336 7.96151 12.3336C8.23418 12.3336 8.46901 12.4321 8.66601 12.6291C8.86301 12.8261 8.96151 13.061 8.96151 13.3336C8.96151 13.6063 8.86301 13.8411 8.66601 14.0381C8.46901 14.2351 8.23418 14.3336 7.96151 14.3336Z"
          fill="#111111"
        />
      </g>
    </g>
  </svg>
);

export const AccordionPanel: React.FC<AccordionPanelProps> = ({
  title,
  children,
}) => {
  return (
    <div className={styles.accordionPanel}>
      <div className={styles.header}>
        <h3 className={styles.title}>{title}</h3>
        <div className={styles.iconWrapper}>
          <div className={styles.circle}>
            <QuestionIcon />
          </div>
        </div>
      </div>
      <div className={styles.content}>{children}</div>
    </div>
  );
}; 